import script from "./CallsHistoryNarrowTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CallsHistoryNarrowTable.vue?vue&type=script&setup=true&lang=js"

import "./CallsHistoryNarrowTable.vue?vue&type=style&index=0&id=bcbb0394&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bcbb0394"]])

export default __exports__